export default __webpack_public_path__ + "static/media/background.51f973d2.png";